var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { useState, useContext } from 'react';
import { Box, Paper, } from '@mui/material';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
// Internal dependencies
import { axiosClient } from '../axios';
import { getAuthHeader } from '../auth';
import { UserContext } from '../auth';
import { LOG_LEVELS, SERVICES, ENDPOINTS, } from '../constants';
import { CreateBrandVoiceDialog, } from './CreateBrandVoiceDialog';
import { BrandVoiceHeader } from './BrandVoiceHeader';
import { BrandVoicesSubtitle } from './BrandVoicesSubtitle';
import { BrandVoicesTable } from './BrandVoicesTable';
;
/**
 * BrandVoices element
 * @param props Brand voices props
 * @returns Brand Voices element
 */
export const BrandVoices = function (props) {
    // Get translation
    const { t, i18n } = useTranslation();
    // Extract output language
    const { outputLanguage } = useOutletContext();
    // Get user credential
    const user = useContext(UserContext);
    // Rerender when delete
    const [reloadBrandVoicesFlag, setReloadBrandVoicesFlag] = useState(0);
    // Delete Brand Voice ids 
    const [deleteBrandVoiceIds, setDeleteBrandVoiceIds] = useState([]);
    /**
     * Handle Delete confirm click
     */
    const handleDeleteConfirmClick = () => __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c;
        try {
            // Get auth header
            const authHeader = yield getAuthHeader(user);
            const headers = Object.assign(Object.assign({}, authHeader), { 'Accept-Language': i18n.language });
            // Delete brandVoices
            yield axiosClient.post(`${process.env.SERVER_URL}${ENDPOINTS.CHAT}${ENDPOINTS.DELETE_BRAND_VOICES}`, { ids: deleteBrandVoiceIds }, { headers });
            // Update delete count to rerender after deleted
            setReloadBrandVoicesFlag(reloadBrandVoicesFlag + 1);
        }
        catch (err) {
            axiosClient.post(`${process.env.LOGGER_SERVER_URL}${ENDPOINTS.LOGGER}${ENDPOINTS.LOG}`, {
                level: LOG_LEVELS.ERROR,
                logMessage: `BrandVoices, handleDeleteConfirmClick, ${err === null || err === void 0 ? void 0 : err.message}`,
                metadata: {
                    env: process.env.ENV,
                    service: SERVICES.AI_CHAT,
                    userId: user === null || user === void 0 ? void 0 : user.uid,
                    email: user === null || user === void 0 ? void 0 : user.email,
                    userAgent: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent,
                },
            });
            // Check if the error is from axios
            if ((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) {
                // If yes, notify user with the server error message
                toast.error((_c = (_b = err === null || err === void 0 ? void 0 : err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message);
                return;
            }
            ;
            toast.error(t('Something went wrong. We are figuring it out.'));
        }
        ;
    });
    // Create dialog open/close
    const [createDialogOpen, setCreateDialogOpen] = useState(false);
    /**
     * Open Brand voice diaglo
     */
    const openBrandVoiceDialog = () => {
        setCreateDialogOpen(true);
    };
    // Selected brand voice
    const [selectedBrandVoice, setSelectedBrandVoice] = useState();
    /**
     * Handle New click open
     */
    const handleNewClickOpen = () => {
        setSelectedBrandVoice(undefined);
        setCreateDialogOpen(true);
    };
    /**
     * Handle New click close
     */
    const handleNewClickClose = () => {
        setSelectedBrandVoice(undefined);
        setCreateDialogOpen(false);
    };
    const /** Delete button disabled */ deleteDisabled = deleteBrandVoiceIds.length <= 0;
    return (_jsxs(Paper
    // Brand Voice container
    , Object.assign({ 
        // Brand Voice container
        sx: {
            background: '#FFFFFF',
            boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.05)',
            borderRadius: '1rem',
            height: 'calc(100%)',
            boxSizing: 'border-box',
            overflow: 'hidden',
            padding: {
                sm: '1.5rem',
                xs: '0.5rem',
            },
        } }, { children: [_jsx(BrandVoiceHeader, { disabled: deleteDisabled, handleDeleteConfirmClick: handleDeleteConfirmClick, handleNewClick: handleNewClickOpen }), _jsx(Box, Object.assign({ sx: {
                    height: 'calc(100% - 40px)',
                    overflow: 'auto',
                    padding: '1.5rem 0 0',
                } }, { children: _jsxs(Box, { children: [_jsx(BrandVoicesSubtitle, {}), _jsx(BrandVoicesTable, { setSelectedBrandVoice: setSelectedBrandVoice, deleteBrandVoiceIds: deleteBrandVoiceIds, setDeleteBrandVoiceIds: setDeleteBrandVoiceIds, reloadBrandVoicesFlag: reloadBrandVoicesFlag, openBrandVoiceDialog: openBrandVoiceDialog })] }) })), _jsx(CreateBrandVoiceDialog, { createDialogOpen: createDialogOpen, handleNewClickClose: handleNewClickClose, inputBrandVoice: selectedBrandVoice, outputLanguage: outputLanguage, reloadBrandVoicesFlag: reloadBrandVoicesFlag, setReloadBrandVoicesFlag: setReloadBrandVoicesFlag })] })));
};
